export default {
  cognito: {
    REGION: "eu-west-1",
    USER_POOL_ID: "eu-west-1_XSSVX7uCs",
    APP_CLIENT_ID: "53pe3hs382ti7cjrutnjsoa6s9",
    IDENTITY_POOL_ID: "eu-west-1:7610cfcd-72fb-480c-a77a-faae95a8e1e6"
  }
};